<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <div class="col-sm-9">
            <span>Vehicle</span>
        </div>
        <div class="col-sm-3"
             *ngIf="parent.suiteData && parent.directoryService.account.canUpdate('bldn', parent.suiteData.building.id)">
            <button type="button" class="btn btn-w-m btn-primary pull-right" (click)="create()">
                <i class="fa fa-plus-circle"></i> Add Vehicle
            </button>
        </div>
    </div>

    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form *ngIf="data"
                  #form="ngForm"
                  (ngSubmit)="update(form)"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <span *ngIf="parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                      class="label archived-item m-b-sm">
                    Archived
                </span>

                <car-owner-field [ngModel]="+data.owner?.id"
                                 name="owner"
                                 [title]="'Car Owner'"
                                 [optionTitleKey]="'fullName'"
                                 [suiteId]="data.suite"
                                 [ownerName]="data.ownerName"
                                 [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                                 (update)="updateCarOwner(form)">
                </car-owner-field>

                <input-field [ngModel]="data.licensePlate"
                             name="licensePlate"
                             [required]="true"
                             [title]="'License Plate #'"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({licensePlate: form.value.licensePlate});
                                       updateNameInList('vehicleList', data.id, 'licensePlate',form.value.licensePlate)">
                </input-field>

                <input-field [ngModel]="data.permitNumber"
                             name="permitNumber"
                             [required]="true"
                             [title]="'Permit Number'"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({permitNumber: form.value.permitNumber})">
                </input-field>

                <input-field name="brand"
                             [title]="'Make'"
                             [ngModel]="data.brand"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({brand: form.value.brand})">
                </input-field>

                <input-field [ngModel]="data.model"
                             name="model"
                             [title]="'Model'"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({model: form.value.model})">
                </input-field>

                <input-field [ngModel]="data.year"
                             name="year"
                             [title]="'Year'"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({year: form.value.year})">
                </input-field>

                <input-field [ngModel]="data.color"
                             name="color"
                             [title]="'Color'"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({color: form.value.color})">
                </input-field>

                <datetime-field [ngModel]="data.moveOutDate"
                                name="moveOutDate"
                                [title]="'Move Out Date'"
                                [value]="data.moveOutDate"
                                [classLabel]="'dv-label col-sm-3 strong'"
                                [classValueBox]="'dv-value col-sm-9'"
                                [classValueEditBox]="'dv-value-edit col-sm-9'"
                                [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                                (update)="update({moveOutDate: convertDate(form.value.moveOutDate)})">
                </datetime-field>

                <textarea-field [ngModel]="data.note"
                                [maxLength]="255"
                                name="note"
                                [title]="'Notes'"
                                [value]="data.note"
                                [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                                (update)="update({note: form.value.note})">
                </textarea-field>

                <div class="btn-group" *ngIf="data.id && data.isCanDelete">
                    <a data-toggle="dropdown" class="btn btn-default btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <li>
                            <a (click)="remove()">Delete</a>
                        </li>
                        <li (click)="moveOut(title)"
                            *ngIf="data.isCanDelete && (!data.moveOutDate || parent.directoryService.dateIsLaterThanCurrent(data.moveOutDate))">
                            <a>Move Out</a>
                        </li>
                        <li (click)="restore()"
                            *ngIf="data.isCanEdit && parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                            <a>Restore</a>
                        </li>
                    </ul>
                </div>

            </form>
        </div>
    </div>
    <spinner [spinnerShow]="parent.spinnerShow"></spinner>
</div>

<div class="boxForModal" *ngIf="isCreateModal && parent.suiteData">
    <vehicle-create [closeTrigger]="hideModal"
                    (onPopupClose)="hideModal()"
                    [buildingId]="parent.suiteData.building.id"
                    [suiteId]="parent.suiteData.id"
                    [inDirectoryItemView]="true">
    </vehicle-create>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/vehicles/vehicles.template.html